import { useCallback, useEffect, useState } from 'react';
import {
  getDeclarations,
  getDraftCopies,
  getFinalCopies,
  getTaxSummaries,
} from '../services/taxFilingsService';
import { useTaxYearStore } from '@/features/tax-year/store/taxYearStore';

/** Aggregated count of tax filing documents for dashboard stats. */
export function useTaxFilingsCount() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const effectiveYear = useTaxYearStore((s) => s.getEffectiveYear());
  const configFetched = useTaxYearStore((s) => s.configFetched);

  const fetchCount = useCallback(async () => {
    if (effectiveYear == null) return;
    setIsLoading(true);
    try {
      const [summaries, drafts, declarations, finals] = await Promise.all([
        getTaxSummaries(effectiveYear),
        getDraftCopies(effectiveYear),
        getDeclarations(effectiveYear),
        getFinalCopies(effectiveYear),
      ]);
      setCount(
        summaries.length + drafts.length + declarations.length + finals.length
      );
    } catch {
      setCount(0);
    } finally {
      setIsLoading(false);
    }
  }, [effectiveYear]);

  useEffect(() => {
    if (!configFetched || effectiveYear == null) return;
    fetchCount();
  }, [configFetched, effectiveYear, fetchCount]);

  return {
    count,
    isLoading: isLoading || !configFetched,
  };
}
